import React from "react";
import InputText from "../ReusableComponents/InputText";
import TextArea from "../ReusableComponents/TextArea";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import MultiSelect from "../ReusableComponents/MultiSelect";

const HouseKeepingPopup = ({ data, data1, data2, bindEmployeeName }) => {
  
  const selectedEmployee = data?.EmployeeID
    ? { value: data.EmployeeID, label: data.Employee || "" }
    : { value: "", label: "" };

  console.log(data2, data1, data, "data1")
  return (
    <div className="w-full">
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 p-4">
        <InputText
          inputType="text"
          title="HouseKeepingId"
          name="HouseKeepingId"
          content={data?.HouseKeepingNo || ""}
          classStar="text-red-500"
          disabled
        />
        <InputText
          inputType="date"
          title="Date"
          name="Date"
          content={data?.Date.split("T")[0] || ""}
          classStar="text-red-500"
          disabled
        />
        <AutoDropDown
          title="Room Type"
          Option={{ value: data?.RoomType, label: data?.RoomTypeLabel }}
          placeholder="Room Type"
          selectedOption={
            data?.RoomType
              ? { value: data.RoomType, label: data.RoomTypeLabel }
              : null
          }
          classStar="text-red-500"
          name="RoomType"
          Class="custom-class"
          disabled
        />
        <AutoDropDown
          title="Room"
          Option={{ value: data?.Room, label: data?.Room }}
          placeholder="Select"
          classStar="text-red-500"
          name="Room"
          selectedOption={data1?.[2] ? [data1[2]] : []}
          Class="custom-class"
          disabled
        />
        <AutoDropDown
          title="RoomStatus"
          Option={{ value: data?.RoomStatus, label: data?.RoomStatusLabel }}
          selectedOption={{ value: data?.RoomStatus, label: data?.RoomStatusLabel }}
          placeholder="Select"
          classStar="text-red-500"
          name="RoomStatus"
          content={data?.RoomStatus || ""}
          Class="custom-class"
          disabled
        />
        <InputText
          inputType="text"
          title="Employee ID"
          name="EmployeeID"
          classStar="text-red-500"
          content={data?.EmployeeID || ""}
          disabled
        />
        <AutoDropDown
          title="Employee Name"
          name="EmployeeName"
          options={bindEmployeeName} 
          placeholder="Select"
          classStar="text-red-500"
          selectedOption={selectedEmployee}
          Class="custom-class"
          disabled
        />
        <InputText
          name="EmployeePosition"
          title="Employee Position"
          content={data?.EmployeePosition || ""}
          classStar="text-red-500"
         
          disabled={true}

        />
        <InputText
          inputType="time"
          title="In Time"
          name="InTime"
          classStar="text-red-500"
          content={data?.InTime || ""}
          disabled
        />
        <InputText
          inputType="time"
          title="Out Time"
          name="OutTime"
          classStar="text-red-500"
          content={data?.OutTime || ""}
          disabled
        />
        <div className="col-md-4">
          <div className="form-group custom-class">
            <label htmlFor="MaintananceActivity" className="form-label"   class="custom-class"  mandatory={true} classStar="text-red-500">
              Maintanance Activity <span className="text-red-500">*</span>
            </label>
            <MultiSelect
            classStar="text-red-500"
              title="MaintananceActivity"
              name="MaintananceActivity"
              filteredOptions={data2}
              placeholder="Select"
              selectedOptions={
                data?.ActivityIds1 ? JSON.parse(data.ActivityIds1) : []
              }
                class="custom-class"
              //selectedOptions={[1,2]}
             
              disabled
            />
          </div>
        </div>
      </div>
      <div className="p-4">
        <TextArea
          title="Description"
          rows={7}
          name="description"
          content={data?.Description || ""}
          resize={false}
          placeholder="Enter description"
          disabled
        />
      </div>
    </div>
  );
};

export default HouseKeepingPopup;
